import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const updatePriceGap=({
    bodyGap,
    goalGap
},token)=>async dispatch=>{
    dispatch({
        type:actionTypes.UPDATE_PRICE_GAP_START
    })
    const options={
        url:`${api}/priceGaps`,
        method:'PUT',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{
            bodyGap,
            goalGap
        }
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.UPDATE_PRICE_GAP_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.UPDATE_PRICE_GAP_FAIL,
                payload:getMessage(error)
            }))
}